// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/*  --arrow-s: 10px;*/\n.Choose3__trigger {\n    border-radius: var(--border-r);\n  }\n/*  & &__search .__el { padding-left: 30px }*/\n.Choose3 .Choose3__search .Icon--search {\n    right: 12px;\n    left: initial;\n  }\n", ""]);
// Exports
module.exports = exports;
